import {
  Elevation,
  CaptionText,
  Button,
  Card,
  Link,
  Container,
  ShareIosIcon,
  Col,
  Row,
} from '@paypalcorp/pp-react'
import React, { useContext, useState } from 'react'
import ProfileCover from './components/ProfileCover'
import {
  Context as WorldReadyContext,
  Message,
} from '@paypalcorp/worldready-react'
import * as styles from './smallerScreenGroupDetail.css'
import * as commonStyles from './index.css'
import { formatMessage } from '../../utils/localization/format_worldready'
import ShareMobile from './components/ShareMobile'
import { GROUP_STATUS } from '../../constants'
import { getGroupDetailPageVariant, tracking } from '../../lib/analytics/fpti'
import Events from '../../lib/analytics/eventTags.js'
import serverData from '../../utils/server-data'
interface SmallerScreenProps {
  HeaderGroup: React.ReactNode
  StripComponent: React.ReactNode
  ActivityComponent: React.ReactNode
  FlatProgressComponent: React.ReactNode
  isPayPalUser: boolean
  isAdmin: boolean
  formattedCreatorInfo: any
  closingDate: string
  shareLink: string
  reportLink: string
  groupStatus?: string
  handleContributeAsUser: () => void
  handleContributeAsGuest: () => void
  handleClickOnReport: () => void
  groupId: string
}

const SmallerScreenGroupDetail: React.FC<SmallerScreenProps> = (
  props: SmallerScreenProps,
) => {
  const {
    HeaderGroup,
    StripComponent,
    ActivityComponent,
    FlatProgressComponent,
    isPayPalUser,
    isAdmin,
    formattedCreatorInfo,
    closingDate,
    shareLink,
    reportLink,
    groupStatus,
    handleContributeAsUser,
    handleContributeAsGuest,
    handleClickOnReport,
    groupId,
  } = props
  const worldReadyC = useContext(WorldReadyContext)
  const [isShareSheetOpen, setIsShareSheetOpen] = useState(false)

  const isActiveGroup = groupStatus === GROUP_STATUS.ACTIVE

  const toggleShareSheet = () => {
    setIsShareSheetOpen(!isShareSheetOpen)
  }

  const formattedClosingDate: string = formatMessage({
    worldReady: worldReadyC,
    contentId: 'flatProgress.acceptingContributionsUntil',
    formatOptions: { closing_date: closingDate },
  })

  const handleClickOnContributePayPal = () => {
    tracking(
      Events.p2p_pools_detail_contribute_with_paypal_pressed({
        source: serverData.trackingParameters.externalSource,
        page_variant: getGroupDetailPageVariant(isAdmin, isPayPalUser),
        pool_id: groupId,
      }),
    )
    handleContributeAsUser()
  }

  const handleClickOnContributeAsUser = () => {
    tracking(
      Events.p2p_pools_detail_contribute_pressed({
        source: serverData.trackingParameters.externalSource,
        page_variant: getGroupDetailPageVariant(isAdmin, isPayPalUser),
        pool_id: groupId,
      }),
    )
    handleContributeAsUser()
  }

  const ReportComponent = (
    <div className={styles.reportGroupStyles} data-testid="reportLink">
      <CaptionText type="strong" as="p" className={commonStyles.description}>
        <Link href={reportLink} target="_blank" onClick={handleClickOnReport}>
          <Message id="detail.reportGroup" />
        </Link>
      </CaptionText>
    </div>
  )

  return (
    <>
      <ShareMobile
        isOpen={isShareSheetOpen}
        shareLink={shareLink}
        isAdmin={isAdmin}
        isPayPalUser={isPayPalUser}
        setIsShareSheetOpen={setIsShareSheetOpen}
        groupId={groupId}
      />
      <div
        className={commonStyles.containerSmallerDivStyles}
        data-testid="main-container"
      >
        <div className={styles.overlaySmallerDivStyles}>
          <div>
            <div className={commonStyles.imageDivStyles}>{StripComponent}</div>
          </div>
          <div
            className={
              isPayPalUser
                ? styles.activityUserDivStyles
                : styles.activityNoUserDivStyles
            }
            data-testid="ppUserContainer"
          >
            <Elevation level={2} className={commonStyles.elevationStyles}>
              <Card className={commonStyles.cardStyles}>
                <Container>
                  <Row>
                    <Col xs={12}>{HeaderGroup}</Col>
                  </Row>
                  <Row>
                    <Col xs={12}>{FlatProgressComponent}</Col>
                  </Row>
                  <ProfileCover creator={formattedCreatorInfo} />
                </Container>
              </Card>
            </Elevation>
            <Container form={true}>
              <Row>
                <Col xs={12}>{ActivityComponent}</Col>
              </Row>
            </Container>
            {!isAdmin && ReportComponent}
          </div>
          <div className={styles.bottomShareContributeStyles}>
            <Elevation level={2}>
              <Container className={styles.elevationDivStyles}>
                <Row className={styles.elevationContent}>
                  <Col xs={12}>
                    <CaptionText as="p" className={styles.closingDate}>
                      {closingDate ? formattedClosingDate : null}
                    </CaptionText>
                  </Col>
                </Row>
                {isActiveGroup && (
                  <>
                    {isPayPalUser ? (
                      <Row data-testid="containerBtns">
                        <Col xs={12}>
                          <Button
                            data-testid="share-sheet-button"
                            variant="secondary"
                            iconComponent={ShareIosIcon}
                            className={styles.buttonFullStyles}
                            onClick={toggleShareSheet}
                          >
                            <Message id="share.share" />
                          </Button>
                        </Col>
                        <Col xs={12}>
                          <Button
                            className={styles.buttonFullStyles}
                            onClick={handleClickOnContributeAsUser}
                            role="button"
                          >
                            <Message id="flatProgress.contribute" />
                          </Button>
                        </Col>
                      </Row>
                    ) : (
                      <>
                        <Row className={styles.guestButtonsContainer} noGutters>
                          <Col xs={12}>
                            <Button
                              data-testid="contributeWithPayPalButton"
                              onClick={handleClickOnContributePayPal}
                              className={styles.buttonFullStyles}
                              role="button"
                            >
                              <Message id="flatProgress.contributePayPal" />
                            </Button>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Button
                              variant="secondary"
                              className={styles.buttonFullStyles}
                              onClick={handleContributeAsGuest}
                              role="button"
                            >
                              <Message id="flatProgress.contributeCard" />
                            </Button>
                          </Col>
                        </Row>
                      </>
                    )}
                  </>
                )}
              </Container>
            </Elevation>
          </div>
        </div>
      </div>
    </>
  )
}

export default SmallerScreenGroupDetail
